// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__fKam3","title":"Checkbox_title__pB56o"};